import { render, staticRenderFns } from "./DowntimeReasonsPiechart.vue?vue&type=template&id=237e8f48"
import script from "./DowntimeReasonsPiechart.vue?vue&type=script&lang=js"
export * from "./DowntimeReasonsPiechart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports